export default __webpack_public_path__ + "static/media/strikepay_qr_icon.75002678.png";